import { useEffect, useRef, useState} from 'react';
import { useSelector , useDispatch} from 'react-redux';
import { projectCreationStepFilter } from '../../redux/reducers/ProjectCreationStepSlice';
import { updateAllUserGroupFollowers, updateFollowersCollection } from '../../redux/reducers/ProjectFollowersSlice';
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods';
import APIUrls from '../../services/APIUrls';
import ReactTooltip from 'react-tooltip';
import Constants from '../../Constants';
import { loginSessionDetail } from '../../redux/reducers/LoginSessionSlice';
import { useNavigate, useParams} from 'react-router-dom';
import { updateSelectedProjectWorkflow } from '../../redux/reducers/SelectedProjectWorkflowSlice';
import { updateInitializedProjectWorkflows } from '../../redux/reducers/InitializedProjectWorkflowsSlice';
import $ from "jquery";
import DataTable from "react-data-table-component";
import { updatePendingWorkflow } from '../../redux/reducers/PendingWorkflowSlice';
import { useTranslation } from 'react-i18next';
import { handleError } from '../../services/authApiRoutes/APImethods';
import { InactiveCannotRequestRevisionIcon, InactiveCanRequestRevisionIcon, FollowerTooltipIcon, InactiveAssigneeManIcon, RemoveFollowerIcon, InactiveMultiAssigneeIcon } from '../../AppIcons';
import ErrorMessage from "../../components/ErrorMessage";
import { timeStamp } from '../../services/Util';

export default function WorkflowAndFollowers() {
    const dispatch = useDispatch();
	const urlParams = new URLSearchParams(window.location.search);
    const param =useParams() 
    const navigate=useNavigate()
    const params = useParams();
    const { t } = useTranslation();
	const translate = t;
    const [toggleexpanded, setToggleexpanded] = useState(false);
    const [refs, setRefs] = useState({});
	const projectFollowersTooltipRef = useRef(null);
    const projectFollowers = useSelector((projectFollowersSlice) => projectFollowersSlice.project_followers);
    const owner = useSelector((loginSessionDetail) => loginSessionDetail.loginSession).value
    const selectedProjectWorkflow = useSelector((selectedProjectWorkflowSlice) => selectedProjectWorkflowSlice.selected_project_workflow).value
    const projectData = useSelector((reduxStore) => reduxStore.project_info).value
    const selectedDept = useSelector((reduxStore) => reduxStore.select_department_for_project_creation).value
    const pendingWorkflow = useSelector((reduxStore) => reduxStore.pending_workflow).value
    const [availableWorkflows, setAvailableWorkflows] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [removedFollowers, setRemovedFollowers] = useState([]);
    const [followersToAdd, setFollowersToAdd] = useState([]);
    const [workAssignees, setWorkAssignees] = useState([]);
    const [showDisabledWorkflowMessage, setShowDisableWorkflowMessage] = useState(false);
    const [disableAddFollowers, setDisableAddFollowers] = useState(true);
    const [disableWorkflowSelection, setDisableWorkflowSelection] = useState(true);
    const [vendorList, setVendorsList] = useState([]);
    const [invalidWorkflowMessage, setInvalidWorkflowMessage] = useState("");

    const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;

    useEffect(() => {
        if(projectFollowers?.followersCollection?.length === 0 ||
            !projectFollowers?.followersCollection.some((follower) => follower.id === projectData?.owner?.userId)) {
            const url = `${APIUrls.DEFAULT_FOLLOWERS_BY_GROUP(selectedDept.value)}?${new URLSearchParams({ projectId: params.id })}`;
            getAxiosResponse(url)
            .then((res) => {
                if (res.data.code === 200) {
                    const options = res.data.data.map(({ resource, displayName }) => ({
                        label: resource?.customerUser?.firstName + " " + resource?.customerUser?.lastName,
                        value: displayName,
                        id: resource?.customerUser?.userId,
                        resource: resource,
                        roleSet: {
                            roleTypes: resource?.customerUser?.roleSet?.roleTypes,
                            roleTypeList: resource?.customerUser?.roleSet?.roleTypeList
                        }
                    }));
                    if(!options.some((follower) => follower.id === projectData?.owner?.userId)) {
                        let owner = {
                            label: projectData?.owner?.firstName + " " + projectData?.owner?.lastName,
                            value: projectData?.owner?.roleSet?.displayName,
                            id: projectData?.owner?.userId,
                            resource: {customerUser:projectData?.owner},
                            roleSet: {
                                roleTypes: projectData?.owner?.roleSet?.roleTypes,
                                roleTypeList: null
                            }
                        }
                        if(owner.id){
                            options.push(owner);
                        }
                    }
                    dispatch(updateFollowersCollection(options));
                }
            })
            .catch((err) => {
                handleError(err);
            });
        } else {
            const url = `${APIUrls.PROJECT_FOLLOWERS(params.id)}`;
            getAxiosResponse(url)
            .then((res) => {
                if(res.data.code === 200) {
                    const options = res.data.data.map(({ resource, displayName }) => ({
                        label: resource?.firstName + " " + resource?.lastName,
                        value: displayName[0].roles,
                        id: resource?.userId,
                        resource: resource,
                        roleSet: {
                            roleTypes: resource?.roleSet?.roleTypes,
                            roleTypeList: resource?.roleSet?.roleTypeList
                        }
                    }));
                    dispatch(updateFollowersCollection(options));
                }
            })
            .catch((err) => {
                handleError(err);
            });
        }
        getAxiosResponse(APIUrls.PROJECT_FOLLOWERS_BY_GROUP(selectedDept.value))
        .then((res) => {
            if (res.data.code === 200) {
                if(res.data.data.length > 0){
                    const options = res.data.data.map(({ resource, displayName }) => ({
                        label: resource?.customerUser?.firstName + " " + resource?.customerUser?.lastName,
                        value: displayName[0]?.role,
                        id: resource?.customerUser?.userId,
                        resource: resource,
                        displayName: displayName,
                        roleSet: {
                            roleTypes: resource?.customerUser?.roleSet.roleTypes,
                            roleTypeList: resource?.customerUser?.roleSet.roleTypeList
                        }
                    }));
                    dispatch(updateAllUserGroupFollowers(options));
                }
            }
        })
        .catch((err) => {
            handleError(err);
        });
        
        Promise.all([getAxiosResponse(APIUrls.PREFERRED_VENDORS(projectData?.userGroup?.id)),
                    getAxiosResponse(APIUrls.AVAILABLE_WORKFLOWS(params.id)),getAxiosResponse(APIUrls.EXISTING_PROJECT_WORKFLOW(params.id, "PENDING"))])
        .then(([vendorResponse, res,pendingWorkFlowResponse])=>{
            const vendors = vendorResponse?.data?.data?.filter((o)=>(o.vendor.automated === false)).map((o)=>(o.vendor));
            if (res.data.code === 200) {
                setDisableWorkflowSelection(false);
                let options = res.data.data.filter(((wf) => wf.workflowType.code !== 'builtin_single_step'));
                let isBasicWorkflowEnabled = res.data.data.filter(((wf) => wf.workflowType.code === 'builtin_single_step'))[0];
                if(isBasicWorkflowEnabled !== undefined) {
                    options.unshift(res.data.data.filter(((wf) => wf.workflowType.code === 'builtin_single_step'))[0]);
                }
                if(projectData?.projectVendorType === Constants.MACHINE_TRANSLATION) {
                    options = options.filter((op) => {
                        if(op.availableForMachineTranslation){
                            if(op.hasAdvancePhase && vendors?.length > 0){
                                return true;
                            }else if(!op.hasAdvancePhase){
                                return true;
                            }else{
                                return false;
                            }
                        }
                    }).map((op)=> op);

                }else{
                    options = options.filter((op) => !op.hasAdvancePhase);
                }
                setAvailableWorkflows(options)
                let selectedWorkflow = null;
                if(pendingWorkFlowResponse.data.code === 200) {
                    dispatch(updatePendingWorkflow(pendingWorkFlowResponse.data.data));
                    let workflowSelection = res?.data?.data?.filter(((wf) => wf.name === pendingWorkFlowResponse?.data?.data[0]?.resource?.templateName))[0];
                    if(workflowSelection !== undefined) {
                        selectedWorkflow = res.data.data.filter(((wf) => wf.name === pendingWorkFlowResponse.data.data[0].resource.templateName))[0];
                        dispatch(updateSelectedProjectWorkflow(selectedWorkflow));
                        setShowDisableWorkflowMessage(false);
                    } else {
                        setShowDisableWorkflowMessage(true);
                    }
                }
                if(selectedWorkflow === null) {
                    if(isBasicWorkflowEnabled !== undefined) {
                        dispatch(updateSelectedProjectWorkflow(options.filter(((wf) => wf.workflowType.code === 'builtin_single_step'))[0]));
                    } else {
                        dispatch(updateSelectedProjectWorkflow(options[0]));
                    }
                    setShowDisableWorkflowMessage(false);
                }

            }
        }).catch((err) => {
            handleError(err);
        });
        getAxiosResponse(APIUrls.WORK_ASSIGNEES(projectData?.userGroup?.id))
        .then((res) => {
            if (res.data.code === 200) {
            res.data.data.map(({ customerUser }) =>
                setWorkAssignees((current) => [...current, customerUser])
            );
            }
        })
        .catch((err) => {
            handleError(err);
        });
    }, []);

    const setAssigneeType = (phase) => {
        const vendorTypeMap = {
            EXTERNAL: translate("other_integrations_project_creation.phase_name_vendor"),
            EXTERNAL_BIDLESS: translate("other_integrations_project_creation.phase_name_vendor"),
            INTERNAL: translate("other_integrations_project_creation.phase_name_translator"),
            MACHINE_TRANSLATION: translate("select_status.machine_translation_request"),
          };
        const vendorType = projectData?.projectVendorType;
        if(phase.phaseType.code === Constants.PHASE_TYPE_PE){
            return phase.assigneeType.display
        }else if (vendorType && phase.assigneeType.display === "Vendor") {
          return vendorTypeMap[vendorType];
        }else{
            return phase.assigneeType.display;
        }
    };

    const setPhaseType = (step, phase, numberOfSteps) => {
        if(phase?.phaseType?.code === 'work')  {
            return (<strong>{phase?.name !== Constants.BLANK ? phase?.name : Constants.PHASE_TYPE_WORK}</strong>);
        } else if(phase?.phaseType?.code === Constants.PHASE_TYPE_PE){
            return <strong>{phase.phaseType.display}</strong>;
        }else {
            if(step?.stepNumber !== numberOfSteps) {
                return (<strong>{step?.phases?.length > 2 ? phase?.name !== Constants.BLANK ? phase?.name : Constants.PHASE_TYPE_REVIEW+ Constants.SINGLE_WHITESPACE +(phase?.phaseNumber-1) : phase.name !== Constants.BLANK ? phase.name : Constants.PHASE_TYPE_REVIEW}</strong>);
            } else {
                return (<strong>{step?.phases?.length !== phase?.phaseNumber ? phase?.name !== Constants.BLANK ? phase?.name : Constants.PHASE_TYPE_REVIEW + Constants.SINGLE_WHITESPACE +(phase?.phaseNumber-1) : phase?.name !== Constants.BLANK ? phase?.name : Constants.FINAL_REVIEW}</strong>);
            }
        }
    }

    const showAssignmentType = () => {
        return (
            selectedProjectWorkflow?.hasMultiAssigneePhase ? 'Multiple Assignees and Timed Phases' : 'Single Assignee'
        )
    }

    const toggleStepExpansion = (e) => {
        toggleexpanded ? setToggleexpanded(false) : setToggleexpanded(true);
         var step = e.target.closest(".workflow-step-list");
        if(step.classList.contains('open-step')) {
            step.classList.remove('open-step')
            $(e.target).attr('aria-expanded', 'false');
        } else {
            step.classList.add('open-step')
            $(e.target).attr('aria-expanded', 'true');
        }
        e.stopPropagation();
    }

    const handleSort = async (column, sortDirection) => {
        $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
          .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
    };

    const removeFollower = (followerId) => {
        var filteredFollowers = projectFollowers.followersCollection.filter(follower => follower.id !== followerId);
        var availableFollowers = projectFollowers.followersCollection.filter(follower => follower.id === followerId);
        setRemovedFollowers(current => [...current, availableFollowers])
        dispatch(updateFollowersCollection(filteredFollowers));
        if($('table tr td .remove-btn').length === 1){
            setTimeout(()=>{
                $('table tr th .first-focus').trigger('focus');
            },200)
          } else if($(document.activeElement).closest('tr').is(':last-child')){
            setTimeout(()=>{
                $('table tr:last-child td .remove-btn').trigger('focus');
            },200)
          }
       
    }

    $(document).ready(function(){
        $(".rdt_Table").attr("aria-label","Add your project's followers");
        $('.rdt_Table input').parent().attr("role","cell");
    });

    const noDataFoundComponent = () => {
        return (
          <div role="rowgroup">
            <div role="row" className="no-data-display align-center">
              <div role="cell">
                <i className="nodata-icon"></i>
                <p>{Constants.NO_RECORD_FOUND}</p>
              </div>
            </div>
          </div>
        );
    };

    function RevisionStatus({ allowRevision }) {
        return (
            <div className="revision-status">
                <div className={`left-icon ${allowRevision ? 'allowed' : 'disallowed'}`}>
                    {allowRevision ? InactiveCanRequestRevisionIcon : InactiveCannotRequestRevisionIcon}
                </div>
                <span className={allowRevision ? 'revision-allowed' : 'revision-disallowed'}>
                    {allowRevision ? 'Can Request Revision' : 'Cannot Request Revision'}
                </span>
            </div>
        );
    }

    const stepData = selectedProjectWorkflow?.steps?.map((step, index) => {
        var numberOfSteps = selectedProjectWorkflow?.steps?.length;
        return (
            <div id={"step-" + step.stepNumber} className={"workflow-step-list"}>
                <div className="inner-step-list">
                    <button type="button" className="step-btn" aria-label={step.name + " step"} onClick={(e) => {toggleStepExpansion(e)}} aria-expanded="false">
                        <i className="plus-icon"></i>
                        {step.name}
                    </button>
                    <div className="workflow-step-content flex">
                        {step.phases.map((phase) => {
                            return (
                                <div className="step-box-list" id={phase.phaseType.display + "-phase-" + phase.phaseNumber}>
                                    <strong>{setAssigneeType(phase)}</strong>
                                    {setPhaseType(step, phase, numberOfSteps)}
                                    {phase.durationInDays !== "" && <div className="step-cal inline-flex disable-focus">
                                        <span>{phase.durationInDays + " day(s)"}</span>
                                    </div>}
                                    <div className="step-assignee flex-center justify-center" aria-label="Single Assignee">
                                        <div className='flex-center'>
                                            <span>{phase?.allowMultiAssignee ? 'Multiple Assignees' : 'Single Assignee'}</span>
                                            {!phase?.allowMultiAssignee ? InactiveAssigneeManIcon : InactiveMultiAssigneeIcon}                                      
                                        </div>
                                    </div>
                                    <div className="step-request">
                                        {phase.isApprovalPhase && <div className='mar-bot6'><span className='w-d100 p-0'>Approval Phase on rejection : </span>{phase?.returnPhaseNumber !== null ? setPhaseType(step, step.phases[phase.returnPhaseNumber-1], step.phases.length): Constants.APPROVAL_PHASE}</div>}
                                        {!phase.allowRevision && <RevisionStatus allowRevision={phase.allowRevision} />}
                                        {phase.allowRevision && <RevisionStatus allowRevision={phase.allowRevision} />}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    });

    function showModel() {
        setTimeout(() => {
            setShowModal(true);
            setDisableAddFollowers(true);
            document.body.classList.add('modal-open');
        }, 200);
        setTimeout(() => {
            $("#close-add-follower-popup").trigger('focus');
            $("input[name='select-all-rows']").on('keydown', function(e) {
                if(e.key === Constants.TAB) {
                    if(e.shiftKey === true){
                        e.preventDefault();
                        $("#close-add-follower-popup").trigger('focus');
                    }
                }
            })
            $(".inner-lightbox-panel").on('keydown', function(e) {
                if(e.key === Constants.ESCAPE) {
                    hideModel();
                }
            })
            $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
            $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
        }, 500);
    }

    function hideModel() {
        setShowModal(false);
        document.body.classList.remove('modal-open');
        $(".first-focus").trigger("focus");
    }

    const handleKeyDownOnCancel = (event) => {
        if(event.key === Constants.TAB){
            if($("input[name='select-all-rows']").length && !event.shiftKey){
                event.preventDefault();
                $("input[name='select-all-rows']").trigger('focus');
            } else if (!$("input[name='select-all-rows']").length) {
                event.preventDefault();
                $("#close-add-follower-popup").trigger('focus');
            }
        }
    };
 
    const columns = [
        {
            name: 'Name',
            selector: row => row.label,
            sortable: true,
        },
        {
            name: 'Role',
            selector: row => row.value,
            sortable: true,
        },
        {
            name: 'Languages',
            selector: row => row?.displayName[0]?.reviewLanguages.length !== 0 ? (row?.displayName[0]?.reviewLanguages.map((lang, index) => index !== row?.displayName[0]?.reviewLanguages.length-1 ? lang.display+", " : lang.display)) : "None",
            sortable: true,
        }
    ];

    const getAddFollowerData = () => {
        let data = projectFollowers.allUserGroupFollowers
                    .filter(follower => !projectFollowers.followersCollection.some(addedFollower => addedFollower.id === follower.id));
        return data;
    }

    const handleFollowerSelect = ({selectedRows}) => {
        selectedRows?.length !== 0 ? setDisableAddFollowers(false) : setDisableAddFollowers(true);
        setFollowersToAdd(selectedRows);
    }

    const handleFollowerAdd = () => {
        dispatch(updateFollowersCollection([...projectFollowers.followersCollection, ...followersToAdd]));
        setRemovedFollowers(removedFollowers.filter(follower => !followersToAdd.some(addedFollower => addedFollower.id === follower[0].id)));
        hideModel();
    }

    const getWorkflowId = (name, workflows) => {
        var workflowId;
        var workflowLength = workflows.length;
        for (var i = 0; i < workflowLength; i++) {
            if (name === workflows[i].name) {
                workflowId = workflows[i].id;
                break;
            }
        }
        return workflowId;
    }

    const changeStepAndInitializeWorkflow = (stepName) => {
        navigate(`/createProject/${param.id}?projectAssetType=${urlParams.get('projectAssetType')}${urlParams.get('projectType')?`&projectType=${urlParams.get('projectType')}`:""}&step=${stepName}`)
        var _existingProjectWorkflows = {};
        if(selectedProjectWorkflow !== undefined || projectData?.clonedFromProjectId !== null) {
            _existingProjectWorkflows = selectedProjectWorkflow;
        } else {
            _existingProjectWorkflows = pendingWorkflow[0]?.resource;
        }
        if(Object.keys(_existingProjectWorkflows).length !== 0) {
            var workflowId = getWorkflowId(_existingProjectWorkflows.templateName || _existingProjectWorkflows.name, availableWorkflows);
            if(!workflowId) {
                setInvalidWorkflowMessage("The workflow you have selected is not valid for the chosen translator. Please select a different workflow");
                return;
            }
            setInvalidWorkflowMessage("");
            navigate(`/createProject/${param.id}?projectAssetType=${urlParams.get('projectAssetType')}${urlParams.get('projectType')?`&projectType=${urlParams.get('projectType')}`:""}&step=${stepName}`)
            getAxiosResponse(APIUrls.INITIALIZED_PROJECT_WORKFLOWS(params.id, workflowId))
            .then((res) => {
                let newInitializedWorkflows = [];
                let newLanguages = []
                pendingWorkflow?.map((pendingWF) => {
                    newInitializedWorkflows.push(pendingWF.resource);
                    newLanguages.push(pendingWF.displayName[0])
                })
                let newData = {
                    resource : newInitializedWorkflows,
                    displayName : newLanguages
                }
                var updatedProjectWorkflows = newData;
                if(res.data?.data?.resource?.length !== 0) {
                    var _currentWorkflow = res.data?.data?.resource;
                    var stepsOfCurrentWorkflow = _currentWorkflow[0].steps;
                    var stepsOfExistingProjectWorkflows = _existingProjectWorkflows.steps;
                    if (stepsOfCurrentWorkflow.length != stepsOfExistingProjectWorkflows.length) {
                        updatedProjectWorkflows = res.data.data;
                    } else if (stepsOfCurrentWorkflow.length == stepsOfExistingProjectWorkflows.length){
                        for (var i = 0; i < stepsOfCurrentWorkflow.length; i++) {
                            if((stepsOfCurrentWorkflow[i].name !== stepsOfExistingProjectWorkflows[i].name) || (stepsOfCurrentWorkflow[i].phases.length !== stepsOfExistingProjectWorkflows[i].phases.length)) {
                                updatedProjectWorkflows = res.data.data;
                            } else if (stepsOfCurrentWorkflow[i].phases.length === stepsOfExistingProjectWorkflows[i].phases.length) {
                                for (var j = 0; j < stepsOfCurrentWorkflow[i].phases.length; j++) {
                                    if (stepsOfCurrentWorkflow[i].phases[j].phaseType.type != stepsOfExistingProjectWorkflows[i].phases[j].phaseType.type
                                        || stepsOfCurrentWorkflow[i].phases[j].assigneeType.type != stepsOfExistingProjectWorkflows[i].phases[j].assigneeType.type
                                        || stepsOfCurrentWorkflow[i].phases[j].customer.id != stepsOfExistingProjectWorkflows[i].phases[j].customer.id
                                    ) {
                                        updatedProjectWorkflows = res.data.data;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                dispatch(updateInitializedProjectWorkflows(updatedProjectWorkflows));
                dispatch(projectCreationStepFilter(stepName));
            })
        }
       setTimeout(()=>{
         $('.workflowData:first .language-schedule-block .remove-btn').trigger('focus')
       },600)
    }

    const updateWorkflowSelection = (workflow) => {
        setShowDisableWorkflowMessage(false);
        dispatch(updateSelectedProjectWorkflow(workflow));
        $(".workflow-step-list").removeClass("open-step");
        $('.step-btn').attr('aria-expanded', 'false')
    }

	$('.tooltip-container p').on('keydown', function(e){
	  if(e.key === Constants.ESCAPE){
		if ($(this).attr('id') === "projectFollowersTooltip") {
		  setRefs(projectFollowersTooltipRef);
		}
	  }
	});

	useEffect(()=>{
		if (refs.current) {
		   refs.current.hideTooltip();
		   setRefs({});
		 }
	}, [refs]);

    return (    
        <>
            <div className="project-heading">
                <h3>{translate("other_integrations_project_creation.workflow_and_followers")}</h3>
                <span>{translate("project_listing.project_workflow")}</span>
                <p>{translate("project_listing.administrator_workflows")}</p>
                {projectData?.projectVendorType === Constants.MACHINE_TRANSLATION && <p>{translate("project_listing.machine_translator_workflows")}</p>}
            </div>
            <div className="flex workflow-content">
                <div className="workflow-list">
                    <strong id='workflow'>Workflow Name</strong>
                    <ul role="tablist" createproject-tour="selectworkflow-list" aria-labelledby="workflow">
                        {availableWorkflows?.map((workflow) => {
                            return <li role="none" key={workflow?.id}>
                                <a href="#" role="tab"
                                 className={selectedProjectWorkflow?.id === workflow?.id || pendingWorkflow?.templateName === workflow?.name ? "active" : ""} onClick= {() => updateWorkflowSelection(workflow)}
                                 aria-label={selectedProjectWorkflow?.id === workflow?.id || pendingWorkflow?.templateName === workflow?.name ? "Current tab," + workflow?.name :  workflow?.name}
                                 aria-selected={selectedProjectWorkflow?.id === workflow?.id || pendingWorkflow?.templateName === workflow?.name ? "true" : "false"}
                                 >
                                    {workflow?.name}
                                </a>
                                </li>
                        })}
                    </ul>
                </div>
                {invalidWorkflowMessage !== "" ? <ErrorMessage class="error-message" message={invalidWorkflowMessage}></ErrorMessage> : ""}
                {!showDisabledWorkflowMessage ? <div className="workflow-main-content">
                    <div className="flex workflow-heading">

                        <h4>{translate("other_integrations_project_creation.workflow_description")}</h4>
                        <button disabled={disableWorkflowSelection} type="button" className="btn btn-bold" onClick={()=>{changeStepAndInitializeWorkflow("Workflow Step 2", selectedProjectWorkflow)}} createproject-tour="select-workflow">Select Workflow</button>

                    </div>
                    <div className="assign-desc-block">
                        <ul className="flex">
                            <li>
                                <strong>{translate("other_integrations_project_creation.name")}</strong>
                                <span>{selectedProjectWorkflow?.name}</span>
                            </li>
                            <li>
                                <strong>{translate("other_integrations_project_creation.assignment_type")}</strong>
                                <span>{showAssignmentType()}</span>
                            </li>
                        </ul>
                        <h6>Description</h6>
                        <p>{selectedProjectWorkflow?.description ? selectedProjectWorkflow?.description : "N/A"}</p>
                    </div>
                    <div className="workflow-step-block">
                        <h6>Workflow Steps</h6>
                        <div className="workflow-wrap clearfix">
                        {stepData}
                        </div>
                    </div>
                    <div className="project-follower-block">
                        <div className='tooltip-container'>
                            <h6>Project followers </h6>
                            <p tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
                             data-padding='10px 10px 10px 10px'
                             id='projectFollowersTooltip'
                             aria-label='tooltip'
                             data-place='bottom'
                             data-tip={Constants.PROJECT_FOLLOWERS_TOOLTIP}
                             data-for='projectFollowers'>
                                {FollowerTooltipIcon}
                                <div className="font-zero">{Constants.PROJECT_FOLLOWERS_TOOLTIP}</div>
                            </p>
                            <ReactTooltip
                              className='tooltip'
                              id='projectFollowers'
                              role='tooltip'
                              ref={projectFollowersTooltipRef}
                            ></ReactTooltip>
                        </div>
                        <p>{translate("project_listing.receive_notifications")}</p>
                        <div className="table-responsive">
                            <table className="table" aria-label="Project followers">
                                <tr>
                                    <th aria-label="Name"> {translate("other_integrations_project_creation.name")}</th>
                                    <th aria-label="Role">{translate("other_integrations_project_creation.role")}</th>
                                    <th><button  type="button" aria-label="Add Follower" onClick={showModel} className='first-focus' createproject-tour="add-followers">Add Follower</button></th>
                                </tr>
                                {Object.entries(projectFollowers.followersCollection).map(([label, value]) => {
                                    return (
                                    <tr>
                                    <td>{value.label} {projectData?.owner?.userId === value.id ? "(Owner)" : ""}</td>
                                    <td>{value.value}</td>
                                    <td>
                                    {projectData?.owner?.userId !== value.id &&
                                        <button type="button" className="remove-btn" onClick={() => {removeFollower(value.id)}}>
                                            {RemoveFollowerIcon} Remove
                                        </button>
                                    }
                                    </td>
                                </tr>
                                    )
                                })}
                            </table>
                        </div>
                    </div>
                </div> : <div><strong>{pendingWorkflow[0]?.resource?.templateName} {translate("other_integrations_project_creation.disabled_workflow_message")}</strong></div>}
            </div>
            {showModal && <div id="modelPopup" className="lightbox-panel" aria-labelledby="followers" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel popup-inner">
                    <div className="modal-header flex popup-header">
                        <strong id='followers'>Add your project's followers</strong>
                    </div>
                    <div className="lightbox-content popup-content">
                        <div className="table-responsive datatable-block">
                            <DataTable
                            columns={columns}
                            data={getAddFollowerData()}
                            onSort={handleSort}
                            selectableRows
                            onSelectedRowsChange={handleFollowerSelect}
                            noDataComponent={noDataFoundComponent()}
                            />
                        </div>
                    </div>
                    <div className="modal-footer popup-footer flex justify-end">
                        <button type="button" id="add-follower" className="btn btn-bold active" onClick={handleFollowerAdd} disabled={disableAddFollowers}>Add</button>
                        <button type="button" id="close-add-follower-popup" className="btn btn-bold" onClick={hideModel} onKeyDown={(e) => handleKeyDownOnCancel(e)}>Cancel</button>
                    </div>
                </div>
            </div>
            }    
            </>        
    )
}